import React from 'react'
import { Box, Button, Flex, Table } from '@workwhile/ui'
import { AccordionCard } from 'components/AccordionCard'
import { TableEmptyState } from 'components/Table/TableEmptyState'
import { useSelectedColumns } from './AssociatedPositionsColumnsFilter/useSelectedColumns'
import {
  AssociatedPositionsProvider,
  useAssociatedPositionsContextValue,
} from '../context/AssociatedPositionsProvider'

const AssociatedPositionsTable = () => {
  const {
    state: { items, isFetching, isFetchingNextPage, hasNextPage },
    actions: { loadMore },
  } = useAssociatedPositionsContextValue()
  const columns = useSelectedColumns()

  if (items.length === 0) {
    return (
      <TableEmptyState
        isFetching={isFetching}
        emptyMessage="No associated positions found"
      />
    )
  }

  return (
    <Box>
      <Table columns={columns} data={items} textVerticalAlign="top" />
      {hasNextPage ? (
        <Flex mt={3}>
          <Button
            variant="secondary"
            loading={isFetchingNextPage || isFetching}
            onClick={loadMore}
          >
            Load more
          </Button>
        </Flex>
      ) : null}
    </Box>
  )
}

export const AssociatedPositions = () => {
  return (
    <AccordionCard
      title="Associated Positions"
      size="large"
      contentWrapperProps={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AssociatedPositionsProvider>
        <AssociatedPositionsTable />
      </AssociatedPositionsProvider>
    </AccordionCard>
  )
}
